module.exports = __webpack_public_path__ + "static/media/SiteStep2.3253c414.svg";